 // Body load opacity
 $(window).on("load",(function(){ 
  var $body = $("body");
  if ($body.length) {
    $body.animate({opacity:1},700);
  }

  // Guard: Check if elements exist before manipulating
  var $anchorTitle = $('#anchor-product .title');
  var $anchorCards = $('#anchor-product .cards');
  if ($anchorTitle.length) {
    $anchorTitle.addClass('animate');
  }
  if ($anchorCards.length) {
    $anchorCards.addClass('animate');
  }
  
  setTimeout(function() {
    var $klTeaser = $('.kl-teaser-WC6DCG');
    if ($klTeaser.length) {
      $klTeaser.trigger('click');
    }
  }, 2000);
 }));

 
// $(window).on('load resize', function () {
// var aanheight = $('.announcement-bar-section').height();
//   $('.header-section').css('top', aanheight);

 
//              });






// Guard: Only bind if elements exist
if ($('.mo_subparant').length > 0) {
  $('.mo_subparant').on('click', function () {
    var $next = $(this).next('.mosubmenu_nav');
    if ($next.length) {
      $next.slideToggle();
    }
    $(this).toggleClass('active');
  });
}


$(document).ready(function() {
  // Guard: Only initialize slick if the library is loaded and element exists
  if (typeof $.fn.slick !== 'undefined' && $('.multi-slider').length > 0) {
    $('.multi-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      loop: false,
      infinite: false,
      autoplay: false,
      fade: false,
      responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }]
    });
  }
});










